<template>
  <iframe id="webiframe" v-if="show_frame" :src="loginUrl" width='400' height='400'
    style='position: absolute; top: -10000px; left: -10000px'></iframe>
  <form class="welcome__form"  @submit.prevent="onLogin">
    <fieldset class="welcome__fieldset">
      <label class="welcome__label">Email
        <input class="input" type="text"
          v-model.trim="login" :placeholder='$t("enter_email1")' required/>
      </label>
      <label class="welcome__label">{{$t("password")}}
        <input class="input" type="password" 
        v-model="psw" @keydown.space.prevent :placeholder="$t('enter_password')" required />
      </label>
      <div class="checkbox">
        <input class="checkbox__input" type="checkbox" id="welcome-check-remember" v-model="checkbox1"/>
        <label class="checkbox__label" for="welcome-check-remember">{{$t("remember_me")}}</label>
      </div>
    </fieldset>
    <button class="button button--primary" type="submit">
      <span class="button__text">{{!isLoading ? $t("enter") : ''}}</span>
      <second-spinner v-if="isLoading" class="spinner_class"></second-spinner>
    </button>
  </form>
  <button class="button button--secondary" type="button" @click="wmlogin()">
    <span class="button__text">{{$t("as_wmt_user")}}</span>
  </button>
  <base-dialog :show="!!error" :widthProgressBar='widthProgressBar' @close="handleError" title="An error occured!">
    <p>{{ error }}</p></base-dialog>
</template>
<script>
import {getCookie} from '../../helpers/CookiesHelper';
import {LOGIN_URL} from '../../helpers/constants'
import {loadWM} from '@/components/helpers/LoadWM.js';
import PushMixin from "@/components/mixins/PushMixin";

export default {
  name: "LoginForm",
  props: {
    data_wmid: String,
    status: String
  },
  emits: ['onload_page', 'change_status', 'silent_login_success'],
  mixins: [PushMixin],
  data() {
    return {
      checkbox1: false,
      login: "",
      psw: "",
      error: null,
      isLoading: false,
      loginUrl: '',
      show_frame: false,
      rid: ''
    };
  },
  computed: {
    getIframeHref(){
      const webiframe = document.getElementById('webiframe')
      if(webiframe)
        return webiframe?.location?.href
      return null
    }
  },
  watch: {
    async status(){
      await this.statusHandler()
    },
    login(next){
      this.login = next.toLowerCase()
    }
  },
  methods: {
    wmlogin(){
      window.location.href = '/auth/wm/login';
    },
    async onLogin(){
      if (this.isLoading) {
        return;
      }
      this.error = null
      this.isLoading = true;
      const actionPayload = {
        username: this.login,
        password: this.psw,
      }
      try {
        await this.$store.dispatch("loginPassword", actionPayload);
        const redirectToPath = getCookie('redirect')
        const redirectUrl = redirectToPath || "/mail";
        window.location.href = redirectUrl;
      } catch (err) {
        if(err?.message === 'User not found'){
          this.error = this.$t('user_not_found')
        } else {
          this.error = err.message || "Failed to authenticate, try later.";
        }
        this.widthPB()
        console.log("error", err.message)
      }
      this.isLoading = false;
    },
    async checkAccess(silentLoginSuccess){
      try {
        await this.$store.dispatch('loadUser')
        const redirectToPath = getCookie('redirect')
        const redirectUrl = redirectToPath || "/mail";
        this.email = this.$store.getters['user'].Email
        const lang = this.$store.getters['getLanguage']
        if(this.rid && this.email && lang) loadWM(this.email.substr(0, 12), lang, this.rid)
        if(silentLoginSuccess) this.$emit('silent_login_success')
        this.$router.push(redirectUrl)
      } catch (err) {
        console.log("error", err.message)
        this.$emit('change_status', 'failed')
      }
    },
    async loadFrame(){
      try{
        const rid = await this.$store.dispatch('getRid')
        if(rid && this.data_wmid){
          this.loginUrl = LOGIN_URL + "?NonInteractive=1&wmid=" + this.data_wmid + "&rid=" + rid
          this.show_frame = true
          this.rid = rid
        } else
          this.$emit('onload_page')
      } catch(err){
        console.log('err :>> ', err);
        this.$emit('onload_page')
      }
    },
    async statusHandler(){
      if(this.status === 'load_frame' && this.data_wmid)
        await this.loadFrame() 
      else if(this.status === 'failed' || this.status === 'success')
        this.$emit('onload_page')
    }
  },
  async created(){
    setTimeout(()=>{
      this.$emit('onload_page')
      this.$emit('change_status', 'failed')
    }, 50000)
    const that = this
    window.onmessage = async function(e) {
      if (e.data == 'finish') {
        const wrapper = document.getElementById('welcome__container')
        const iframe = document.getElementById('webiframe')
        if(iframe && wrapper)
          wrapper.removeChild(iframe)
        await that.checkAccess(true)
      }
    }
  },
  async mounted(){
    await this.statusHandler()
  }
};
</script>
